var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tags-filter"},[_c('div',{staticClass:"tags-filter__list"},[_c('button',{staticClass:"tags-filter__item",class:{ 'is-selected': _vm.selected === '' },on:{"click":_vm.clear}},[_vm._v("\n            Все\n        ")]),_vm._v(" "),_vm._l((_vm.data),function(item,index){
var _obj;
return _c('button',{key:index,ref:"tag",refInFor:true,staticClass:"tags-filter__item",class:[
                { 'is-selected': _vm.selected === item.id },
                { 'is-disabled': item.disabled },
                ( _obj = {}, _obj[("tags-filter__item--" + (item.xmlId))] = item.xmlId, _obj )
            ],domProps:{"innerHTML":_vm._s(item.text)},on:{"click":function($event){return _vm.onClick(item)}}})})],2)])}
var staticRenderFns = []

export { render, staticRenderFns }